// extracted by mini-css-extract-plugin
export default {"countInfo":"styles_countInfo__1pJA3","count":"styles_count__YZcdi","received":"styles_received__lYp6p"};